import { memo, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Sidebar from './sidebar';
import Header from './topbar';
import { LayoutProvider } from '../../contexts/LayoutContext';
import ChildLayout from './child';

import NormalChildLayout from './child/normal';
import { useAuth } from '../../contexts/AuthContext';
import { useDispatch } from 'react-redux';
import { measurementService } from '../../api/measurement';
import { setAllMeasurements } from '../../store/reducers/measurement';
import { allMeasurements } from '../../store/reducers/dropdown';
import { studentsService } from '../../api/students';
import { setLecturerStudents } from '../../store/reducers/students';
import { intermediaryService } from '../../api/intermediary';
import { setAllIntermediaries } from '../../store/reducers/intermediary';
import ScrollToTop from '../ScrollToTop';

const LecturerLayout = memo(({ normal = false }) => {
    const { logout } = useAuth()
    const dispatch = useDispatch()
    const lastCalledRef = useRef(0);

    useEffect(() => {
        if (global?.auth_token) {
            const now = new Date().getTime();
            if (now - lastCalledRef.current > 5000) {
                lastCalledRef.current = now;
                (async () => {
                    try {
                        // Dropdown
                        // const response_accordingToParagraph = await dropdownService.getAllAccordingToParagraph();
                        // if (response_accordingToParagraph) { dispatch(setAllAccordingToParagraph(response_accordingToParagraph?.data)) }
                        // // Bridge Days
                        // const response_bridgeDays = await bridgeDaysService.getAllBridgeDays();
                        // if (response_bridgeDays) { dispatch(setAllBridgeDays(response_bridgeDays?.data)) }
                        // // Examinations
                        // const response_examinations = await examinationsService.getAllExaminations();
                        // if (response_examinations) { dispatch(setAllExaminations(response_examinations?.data)) }
                        // Intermediaries
                        const response_intermediaries = await intermediaryService.getAllIntermediaries();
                        if (response_intermediaries) { dispatch(setAllIntermediaries(response_intermediaries?.data)) }
                        // Measurements
                        const response_measurements = await measurementService.getAllMeasurements();
                        if (response_measurements) {
                            dispatch(setAllMeasurements(response_measurements?.data))
                            dispatch(allMeasurements(response_measurements?.data?.filter(i => i?.show_in_documents == 1)?.map((item, index) => ({ ...item, title: item?.measures_title, measures_title: `${item?.measures_number} - ${item?.measures_title}` }))))
                        }
                        // Users
                        // const response_users = await userService.getAllUsers();
                        // if (response_users) { dispatch(setAllUsers(response_users)) }
                        // // Lecturers
                        // const response_lecturers = await lecturersService.getAllLecturers();
                        // if (response_lecturers) { dispatch(setAllLecturers(response_lecturers?.data)) }

                        // Students
                        const response_students = await studentsService.getLecturerStudents();
                        if (response_students?.success) { dispatch(setLecturerStudents(response_students?.data)) }

                        // // Organization Tree
                        // const response_organizationTree = await carrierFeedbackService.organizationTree();
                        // if (response_organizationTree?.success) { dispatch(setOrganizationTree(response_organizationTree?.data)) }
                    } catch (error) {
                        if (error?.response?.status === 401) { logout?.() }
                    }
                })();
            }
        }
    }, [global.auth_token]);

    return (
        <ScrollToTop>
            <LayoutProvider>
                {!normal && (
                    <>
                        <Header key="header" />
                        <Sidebar key="sidebar" type="lecturer" />
                        <ChildLayout key="child" />
                    </>
                )}
                {normal && (<NormalChildLayout key="child" />)}
            </LayoutProvider>
        </ScrollToTop>
    );
});

LecturerLayout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default LecturerLayout;